import React, { useState, useEffect, useRef } from 'react';
import styles from '../styles/Banner.module.css';

const Banner = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [counters, setCounters] = useState({
        kundli: 0,
        languages: 0,
        consultations: 0,
        customers: 0
    });
    
    const bannerRef = useRef(null);

    const statsData = [
        { key: 'kundli', target: 150, suffix: 'k+', label: 'Kundli Served', icon: '📊' },
        { key: 'languages', target: 8, suffix: '+', label: 'Language Report', icon: '🌐' },
        { key: 'consultations', target: 20, suffix: 'k+', label: 'Personal Consultation', icon: '👥' },
        { key: 'customers', target: 200, suffix: 'k+', label: 'Happy Customer', icon: '😊' }
    ];

    useEffect(() => {
        if (!bannerRef.current) {
            return undefined;
        }

        if (typeof window === 'undefined' || typeof window.IntersectionObserver !== 'function') {
            // Older browsers (or polyfill failures) simply reveal the stats without animation
            setIsVisible(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        observer.observe(bannerRef.current);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (isVisible) {
            statsData.forEach((stat) => {
                let start = 0;
                const increment = stat.target / 50;
                const timer = setInterval(() => {
                    start += increment;
                    if (start >= stat.target) {
                        setCounters(prev => ({ ...prev, [stat.key]: stat.target }));
                        clearInterval(timer);
                    } else {
                        setCounters(prev => ({ ...prev, [stat.key]: Math.floor(start) }));
                    }
                }, 40);
            });
        }
    }, [isVisible]);

    return (
        <section className={styles.bannerHome} ref={bannerRef}>
            <div className="container">
                <div className={styles.statsContainer}>
                    <div className={styles.statsHeader}>
                        <h2 className={styles.statsTitle}>Our Achievement in Numbers</h2>
                        <p className={styles.statsSubtitle}>Trusted by thousands of satisfied customers worldwide</p>
                    </div>
                    <div className={styles.statsGrid}>
                        {statsData.map((stat) => (
                            <div key={stat.key} className={styles.statCard}>
                                <div className={styles.statIcon}>{stat.icon}</div>
                                <div className={styles.statNumber}>
                                    {counters[stat.key]}{stat.suffix}
                                </div>
                                <div className={styles.statLabel}>{stat.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;